var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "d-flex h-100 w-100" }, [
    _vm.isLoading
      ? _c(
          "div",
          {
            staticClass:
              "d-flex justify-content-center align-items-center w-100"
          },
          [
            _c("div", {
              staticClass: "d-flex spinner-border text-dark",
              attrs: { role: "status" }
            })
          ]
        )
      : _c("div", { staticClass: "w-100" }, [
          _c("h3", { staticClass: "mt-3" }, [
            _vm._v(" " + _vm._s(_vm.formLabel) + " ")
          ]),
          _c("div", { staticClass: "alert alert-light" }, [
            _vm.isAnswered
              ? _c("div", { staticClass: "text-center" }, [
                  _c("h3", [
                    _vm._v("Merci d'avoir pris le temps de répondre !")
                  ]),
                  _c("p", { staticClass: "question-hint" }, [
                    _vm._v(" Vous pouvez fermer cette fenêtre. ")
                  ])
                ])
              : _c("div", [
                  _c("h4", { staticClass: "question-label" }, [
                    _vm._v(
                      "Dans quel type de logement la box Emotivi sera installée ?"
                    )
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v(
                      "Choississez une valeur dans le menu déroulant ci-dessous."
                    )
                  ]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.buildingType,
                          expression: "buildingType"
                        }
                      ],
                      staticClass: "form-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.buildingType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.buildingTypes, function(buildingType, index) {
                      return _c("option", { attrs: { index: index } }, [
                        _vm._v(_vm._s(buildingType))
                      ])
                    }),
                    0
                  ),
                  _c("h4", { staticClass: "question-label mt-4" }, [
                    _vm._v(
                      "Pouvez-vous précisez le fournisseur d'accès à internet du logement ?"
                    )
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v(
                      "Choississez une valeur dans le menu déroulant ci-dessous."
                    )
                  ]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.internetProvider,
                          expression: "internetProvider"
                        }
                      ],
                      staticClass: "form-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.internetProvider = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.internetProviders, function(
                      internetProvider,
                      index
                    ) {
                      return _c("option", { attrs: { index: index } }, [
                        _vm._v(_vm._s(internetProvider))
                      ])
                    }),
                    0
                  ),
                  _c("h4", { staticClass: "question-label mt-4" }, [
                    _vm._v(
                      "Pouvez-vous précisez le type de connexion du fournisseur d'accès ?"
                    )
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v(
                      "Choississez une valeur dans le menu déroulant ci-dessous."
                    )
                  ]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.connectionType,
                          expression: "connectionType"
                        }
                      ],
                      staticClass: "form-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.connectionType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.connectionTypes, function(
                      connectionType,
                      index
                    ) {
                      return _c("option", { attrs: { index: index } }, [
                        _vm._v(_vm._s(connectionType))
                      ])
                    }),
                    0
                  ),
                  _c("h4", { staticClass: "question-label mt-4" }, [
                    _vm._v(
                      "Pouvez-vous précisez par quel moyen le senior regarder les chaines de télévision ?"
                    )
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v(
                      "Choississez une valeur dans le menu déroulant ci-dessous."
                    )
                  ]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tvChannelsProvider,
                          expression: "tvChannelsProvider"
                        }
                      ],
                      staticClass: "form-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.tvChannelsProvider = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.tvChannelsProviders, function(
                      tvChannelsProvider,
                      index
                    ) {
                      return _c("option", { attrs: { index: index } }, [
                        _vm._v(_vm._s(tvChannelsProvider))
                      ])
                    }),
                    0
                  ),
                  _c("h4", { staticClass: "question-label mt-4" }, [
                    _vm._v("Pouvez-vous précisez la marque du téléviseur ?")
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v(
                      "Choississez une valeur dans le menu déroulant ci-dessous."
                    )
                  ]),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.tvBrand,
                          expression: "tvBrand"
                        }
                      ],
                      staticClass: "form-select",
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.tvBrand = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    _vm._l(_vm.tvBrands, function(tvBrand, index) {
                      return _c("option", { attrs: { index: index } }, [
                        _vm._v(_vm._s(tvBrand))
                      ])
                    }),
                    0
                  ),
                  _c("h4", { staticClass: "question-label mt-4" }, [
                    _vm._v("Habitez-vous à moins de 30 min. du senior ?")
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v("Cochez une réponse ci-dessous.")
                  ]),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.seniorDistance,
                          expression: "seniorDistance"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        name: "senior_distance",
                        type: "radio",
                        id: "senior_distance_yes",
                        value: "1"
                      },
                      domProps: { checked: _vm._q(_vm.seniorDistance, "1") },
                      on: {
                        change: function($event) {
                          _vm.seniorDistance = "1"
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "senior_distance_yes" }
                      },
                      [_vm._v("Oui")]
                    )
                  ]),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.seniorDistance,
                          expression: "seniorDistance"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        name: "senior_distance",
                        type: "radio",
                        id: "senior_distance_no",
                        value: "0"
                      },
                      domProps: { checked: _vm._q(_vm.seniorDistance, "0") },
                      on: {
                        change: function($event) {
                          _vm.seniorDistance = "0"
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "senior_distance_no" }
                      },
                      [_vm._v("Non")]
                    )
                  ]),
                  _c("h4", { staticClass: "question-label mt-4" }, [
                    _vm._v(
                      "Un proche peut-il se rendre sur place en cas de besoin ?"
                    )
                  ]),
                  _c("p", { staticClass: "question-hint m-0" }, [
                    _vm._v("Cochez une réponse ci-dessous.")
                  ]),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.relativeDistance,
                          expression: "relativeDistance"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        name: "relative_distance",
                        type: "radio",
                        id: "relative_distance_yes",
                        value: "1"
                      },
                      domProps: { checked: _vm._q(_vm.relativeDistance, "1") },
                      on: {
                        change: function($event) {
                          _vm.relativeDistance = "1"
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "relative_distance_yes" }
                      },
                      [_vm._v("Oui")]
                    )
                  ]),
                  _c("div", { staticClass: "form-check form-check-inline" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.relativeDistance,
                          expression: "relativeDistance"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        name: "relative_distance",
                        type: "radio",
                        id: "relative_distance_no",
                        value: "0"
                      },
                      domProps: { checked: _vm._q(_vm.relativeDistance, "0") },
                      on: {
                        change: function($event) {
                          _vm.relativeDistance = "0"
                        }
                      }
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "relative_distance_no" }
                      },
                      [_vm._v("Non")]
                    )
                  ])
                ])
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isAnswered,
                  expression: "!isAnswered"
                }
              ],
              staticClass: "text-end mb-3"
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn-large btn-primary",
                  on: { click: _vm.submitForm }
                },
                [_vm._v("Valider")]
              )
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }